<template>
<!--    <svg id="seat-11" xmlns="http://www.w3.org/2000/svg" :width="width"-->
<!--         :height="height" viewBox="0 0 44 28"-->
<!--         class="svg bed-img replaced-svg">-->
<!--        <g id="Group_4650"-->
<!--           transform="translate(-5879 1387) rotate(-90)">-->
<!--            <g id="Rectangle_615"-->
<!--               transform="translate(1359 5879)" :fill="fill"-->
<!--               :stroke="stroke" stroke-width="0.5">-->
<!--                <rect width="28" height="44" rx="4"-->
<!--                      stroke="none"></rect>-->
<!--                <rect x="0.25" y="0.25" width="27.5"-->
<!--                      height="43.5" rx="3.75"-->
<!--                      fill="none"></rect>-->
<!--            </g>-->
<!--            <g id="Rectangle_767"-->
<!--               transform="translate(1361 5879)" :fill="fill"-->
<!--               :stroke="stroke" stroke-width="0.5">-->
<!--                <rect width="24" height="34" rx="2"-->
<!--                      stroke="none"></rect>-->
<!--                <rect x="0.25" y="0.25" width="23.5"-->
<!--                      height="33.5" rx="1.75"-->
<!--                      fill="none"></rect>-->
<!--            </g>-->
<!--            <g id="Rectangle_616"-->
<!--               transform="translate(1365 5915)" :fill="fill"-->
<!--               :stroke="stroke" stroke-width="0.5">-->
<!--                <rect width="16" height="8" rx="2"-->
<!--                      stroke="none"></rect>-->
<!--                <rect x="0.25" y="0.25" width="15.5"-->
<!--                      height="7.5" rx="1.75"-->
<!--                      fill="none"></rect>-->
<!--            </g>-->
<!--        </g>-->
<!--    </svg>-->

    <svg id="seat-hc" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 27.25 32" class="svg seat-img replaced-svg">
        <g id="Group_4653" transform="translate(-5921.75 1322) rotate(-90)" :fill="fill">
            <g id="Rectangle_636" transform="translate(1292 5922)" :fill="fill">
                <path id="Path_1425" d="M4,0H24a4,4,0,0,1,4,4V22a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4A4,4,0,0,1,4,0Z" :fill="fill" stroke="#000" stroke-width="0.5"></path>
            </g>
            <g id="Rectangle_717" transform="translate(1297 5925)" :fill="fill">
                <path id="Path_1433" d="M4,0H14a4,4,0,0,1,4,4V19a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4A4,4,0,0,1,4,0Z" :fill="fill"></path>
                <path id="Path_1434" d="M4,.15H14A3.85,3.85,0,0,1,17.85,4V19A1.85,1.85,0,0,1,16,20.85H2A1.85,1.85,0,0,1,.15,19V4A3.85,3.85,0,0,1,4,.15Z" fill="none" stroke="#c7c7cc" stroke-width="0.3"></path>
            </g>
            <g id="Rectangle_639" transform="translate(1290 5928)" :fill="fill" stroke="#000" stroke-width="0.5">
                <rect width="5" height="18" rx="2" stroke="none"></rect>
                <rect x="0.25" y="0.25" width="4.5" height="17.5" rx="1.75" fill="none"></rect>
            </g>
            <g id="Rectangle_638" transform="translate(1317 5928)" :fill="fill" stroke="#000" stroke-width="0.5">
                <rect width="5" height="18" rx="2" stroke="none"></rect>
                <rect x="0.25" y="0.25" width="4.5" height="17.5" rx="1.75" fill="none"></rect>
            </g>
            <g id="Rectangle_639-2" transform="translate(1293 5943)" :fill="fill" stroke="#000" stroke-width="0.5">
                <rect width="26" height="6" rx="2" stroke="none"></rect>
                <rect x="0.25" y="0.25" width="25.5" height="5.5" rx="1.75" fill="none"></rect>
            </g>
        </g>
    </svg>

</template>

<script>
    export default {
        name: "Seat",
        props: {
            width: {
                type: Number,
                default: 35,
                required: false
            },
            height: {
                type: Number,
                default: 28,
                required: false
            },
            stroke: {
                type: String,
                default: '#000',
                required: false
            },
            fill: {
                type: String,
                default: '#fff',
                required: false
            }
        }
    }
</script>

<style scoped>

    svg#seat-hc {
        transform: rotate(90deg);
    }
</style>
